module.exports = __webpack_public_path__ + "triacomtecnologia/static/media/logoIcon.2242b57c.png";